/* Malia Hair theme behaviours */
(function(){
  'use strict';
  var money = function(c){ return '$' + (c/100).toFixed(2); };

  /* ---------- toast ---------- */
  var toastT;
  window.toast = function(msg){
    var t = document.getElementById('toast'); if(!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function(){ t.classList.remove('on'); }, 2600);
  };

  /* ---------- cart drawer ---------- */
  window.toggleCart = function(on){
    var d = document.getElementById('drawer'), s = document.getElementById('scrim');
    if(!d) return;
    d.classList.toggle('on', on); if(s) s.classList.toggle('on', on);
    document.body.style.overflow = on ? 'hidden' : '';
    if(on) refreshCart();
  };

  /* What a line would have cost at RRP. The Ajax cart has no compare_at_price,
     so the dashed figures come from the map the cart drawer snippet prints;
     anything not in it falls back to its own pre-discount price. */
  function rrpLine(item){
    var m = window.MALIA_RRP || {};
    return (m[item.variant_id] || item.original_price) * item.quantity;
  }

  /* The struck-through figure is the RRP, the same one the product cards and
     the bundle builder show, so the saving reads as the whole gap - the
     everyday discount plus whatever the bundle tier adds on top. */
  function cartLine(item){
    var full = rrpLine(item), cut = full > item.final_line_price;
    return '<div class="citem">' +
      '<a class="citem__v" href="'+item.url+'">'+(item.image?'<img class="ph" src="'+item.image.replace(/(\.[a-z]+)(\?|$)/,'_200x$1$2')+'" alt="">':'')+'</a>' +
      '<div><b>'+item.product_title+'</b><small>'+(item.variant_title && item.variant_title!=='Default Title' ? item.variant_title+' &middot; ' : '')+money(item.price)+' each</small>' +
      '<div style="display:flex;gap:8px;align-items:center;margin-top:6px">' +
        '<button data-line="'+item.key+'" data-d="-1" style="border:1px solid var(--line);width:24px;height:24px;border-radius:50%">&minus;</button>' +
        '<span class="tab" style="font-size:13px;min-width:14px;text-align:center">'+item.quantity+'</span>' +
        '<button data-line="'+item.key+'" data-d="1" style="border:1px solid var(--line);width:24px;height:24px;border-radius:50%">+</button>' +
      '</div></div>' +
      '<b class="tab" style="font-size:14px;white-space:nowrap">'+(cut?'<s style="font-weight:400;color:var(--ink-faint);margin-right:6px">'+money(full)+'</s>':'')+money(item.final_line_price)+'</b></div>';
  }

  /* ---------- build-your-own bundles in the cart ----------
     Every line added from the bundle builder carries the same _byo stamp.
     The cart collapses each stamp into one row - one image, the product
     names, one price - so a bundle reads as a bundle rather than as a pile
     of loose products that happen to be discounted. */
  var CTRASH = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';

  function byoKey(item){ return (item.properties && item.properties._byo) || null; }

  function bundleRow(gid, items){
    var full = 0, paid = 0, list = '';
    items.forEach(function(i){
      full += rrpLine(i);
      paid += i.final_line_price;
      list += '<div>'+i.quantity+'x '+((i.properties && i.properties._byon) || i.product_title)+'</div>';
    });
    var img = window.MALIA_BYOIMG || (items[0].image || '');
    return '<div class="citem">' +
      '<a class="citem__v" href="/pages/build-your-own-bundle">'+(img?'<img class="ph" src="'+img+'" alt="">':'')+'</a>' +
      '<div><b>Build your own bundle</b>' +
        '<div style="margin-top:5px;font-size:12.5px;color:var(--ink-soft);line-height:1.6">'+list+'</div>' +
        '<button type="button" data-byoedit="'+gid+'" style="margin-top:9px;background:none;border:0;padding:0;font:inherit;font-size:12.5px;color:#C7495E;text-decoration:underline;cursor:pointer">edit bundle</button>' +
      '</div>' +
      '<div style="display:flex;flex-direction:column;align-items:flex-end;justify-content:space-between;gap:10px">' +
        '<b class="tab" style="font-size:14px;white-space:nowrap">'+(full>paid?'<s style="font-weight:400;color:var(--ink-faint);margin-right:6px">'+money(full)+'</s>':'')+money(paid)+'</b>' +
        '<button type="button" data-byodel="'+gid+'" aria-label="Remove bundle" style="background:none;border:0;padding:0;line-height:0;color:var(--ink-faint);cursor:pointer">'+CTRASH+'</button>' +
      '</div></div>';
  }

  /* Both of these rewrite the cart by setting the bundle's line quantities to
     zero in one call, so the cart never sits in a half-removed state. */
  function byoLineKeys(gid){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); })
      .then(function(c){ return c.items.filter(function(i){ return byoKey(i)===gid; }); });
  }
  function dropLines(items){
    var updates = {};
    items.forEach(function(i){ updates[i.key] = 0; });
    return fetch('/cart/update.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({updates: updates})
    }).then(function(r){ return r.json(); });
  }
  function removeBundle(gid){
    byoLineKeys(gid).then(dropLines).then(function(cart){
      /* The drawer redraws itself; the /cart page is server-rendered, so
         there is nothing to redraw and it has to come back from Shopify. */
      if(document.getElementById('cartBody')) renderCart(cart);
      else window.location.reload();
    }).catch(function(){});
  }
  function editBundle(gid){
    byoLineKeys(gid).then(function(items){
      var sel = {};
      items.forEach(function(i){ sel[i.handle] = (sel[i.handle]||0) + i.quantity; });
      try{ sessionStorage.setItem('byoEdit', JSON.stringify(sel)); }catch(e){}
      return dropLines(items).then(function(){ window.location.href = '/pages/build-your-own-bundle'; });
    }).catch(function(){ window.location.href = '/pages/build-your-own-bundle'; });
  }

  var PERK = '';
  var ex = null;
  function renderCart(cart){
    var body = document.getElementById('cartBody'), foot = document.getElementById('cartFoot');
    var count = document.getElementById('cartCount');
    if(count) count.textContent = cart.item_count;
    if(!body || !foot) return;
    if(!cart.items.length){
      body.innerHTML = '<p style="color:var(--ink-faint);font-size:14px">Your cart is empty.</p>';
      foot.innerHTML = '';
      return;
    }
    /* Bundle lines collapse into one row each, in the position of the first
       line of the bundle; everything else renders as an ordinary product. */
    var groups = {}, order = [];
    cart.items.forEach(function(i){
      var g = byoKey(i);
      if(g){
        if(!groups[g]){ groups[g] = []; order.push({byo:true, gid:g}); }
        groups[g].push(i);
      } else {
        order.push({byo:false, item:i});
      }
    });
    body.innerHTML = order.map(function(o){
      return o.byo ? bundleRow(o.gid, groups[o.gid]) : cartLine(o.item);
    }).join('');
    /* Totalled off the RRP, not off the line prices, so the figure is the
       whole gap between what the products list at and what this cart costs. */
    var before = 0;
    cart.items.forEach(function(i){ before += rrpLine(i); });
    var saved = before - cart.total_price;
    foot.innerHTML =
      (saved > 0 ? '<div style="display:flex;justify-content:space-between;font-size:13px;color:#C7495E;margin-bottom:7px"><span>You save</span><span class="tab">&minus;'+money(saved)+'</span></div>' : '') +
      '<div style="display:flex;justify-content:space-between;font-size:15px;font-weight:700"><span>Subtotal</span><span class="tab">'+money(cart.total_price)+'</span></div>' +
      '<a class="btn btn--fill btn--wide" href="/checkout" style="text-align:center">Checkout</a>';
    var tpl = document.getElementById('cartExtras');
    if(tpl) foot.insertAdjacentHTML('beforeend', tpl.innerHTML);
  }

  function refreshCart(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(renderCart).catch(function(){});
  }

  function addToCart(id, qty){
    return fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:id, quantity:qty}]})
    }).then(function(r){ return r.json(); }).then(function(){
      refreshCart(); toggleCart(true); toast('Added to cart');
    }).catch(function(){ toast('Sorry, that could not be added'); });
  }

  function changeLine(key, delta){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      var it = c.items.filter(function(i){return i.key===key;})[0];
      if(!it) return;
      return fetch('/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id:key, quantity: Math.max(0, it.quantity + delta)})
      }).then(function(r){return r.json();}).then(renderCart);
    });
  }

  document.addEventListener('click', function(e){
    var ln = e.target.closest('[data-line]');
    if(ln){ changeLine(ln.getAttribute('data-line'), parseInt(ln.getAttribute('data-d'),10)); return; }
    var be = e.target.closest('[data-byoedit]');
    if(be){ editBundle(be.getAttribute('data-byoedit')); return; }
    var bd = e.target.closest('[data-byodel]');
    if(bd){ removeBundle(bd.getAttribute('data-byodel')); return; }
  });

  /* ---------- buy boxes (cards + pdp + feature) ---------- */
  function scope(el){ return el.closest('[data-buy]') || el.closest('.card') || document; }

  /* The "1x" markers in a bundle's What's included list. A twin pack holds two
     of everything, and the quantity stepper multiplies that again, so the
     number has to come from both controls together - it used to follow the
     pack switch alone and sat on 1x or 2x however many the customer ordered. */
  function syncIncl(box){
    if(!box) return;
    var marks = box.querySelectorAll('.inclq');
    if(!marks.length) return;
    var pk = box.querySelector('.cpack.on, .pack2.on') || box.querySelector('.cpack, .pack2');
    var per = (pk && pk.getAttribute('data-k') === 'twin') ? 2 : 1;
    var v = box.querySelector('[data-qtyval]');
    var qty = v ? (parseInt(v.textContent, 10) || 1) : 1;
    var n = per * qty;
    for (var i = 0; i < marks.length; i++) marks[i].textContent = n + 'x';
  }

  document.addEventListener('click', function(e){
    /* pack switch */
    var pk = e.target.closest('.cpack, .pack2');
    if(pk){
      var box = scope(pk);
      box.querySelectorAll('.cpack, .pack2').forEach(function(b){ b.classList.toggle('on', b===pk); });
      var price = box.querySelector('[data-price]');
      if(price) price.innerHTML = pk.getAttribute('data-fmt') || price.innerHTML;
      var q = box.querySelector('[data-quarter]');
      if(q && pk.getAttribute('data-q')) q.textContent = pk.getAttribute('data-q');
      syncIncl(box);
      return;
    }
    /* qty steppers */
    var qb = e.target.closest('[data-qty]');
    if(qb){
      var box2 = scope(qb), val = box2.querySelector('[data-qtyval]');
      if(val){
        var n = parseInt(val.textContent,10) || 1;
        n = Math.max(1, Math.min(20, n + parseInt(qb.getAttribute('data-qty'),10)));
        val.textContent = n;
      }
      syncIncl(box2);
      return;
    }
    /* add to cart */
    var add = e.target.closest('[data-add]');
    if(add){
      var box3 = scope(add);
      var active = box3.querySelector('.cpack.on, .pack2.on') || box3.querySelector('.cpack, .pack2');
      var id = active && active.getAttribute('data-id');
      var v = box3.querySelector('[data-qtyval]');
      var qty = v ? (parseInt(v.textContent,10)||1) : 1;
      if(id){ add.disabled = true; addToCart(id, qty).then(function(){ add.disabled = false; }); }
      return;
    }
  });

  /* ---------- sale timer ---------- */
  function sydSecs(){
    try{
      var p = new Intl.DateTimeFormat('en-AU',{timeZone:'Australia/Sydney',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
      var g = function(t){ return +p.filter(function(x){return x.type===t;})[0].value; };
      return g('hour')*3600 + g('minute')*60 + g('second');
    }catch(e){
      var d = new Date(); return d.getHours()*3600 + d.getMinutes()*60 + d.getSeconds();
    }
  }
  function tickSale(){
    var left = 86400 - sydSecs(); if(left < 0) left += 86400;
    var h = Math.floor(left/3600), m = Math.floor(left%3600/60), s = left%60;
    var pad = function(n){ return n<10 ? '0'+n : ''+n; };
    document.querySelectorAll('[data-st="h"]').forEach(function(e){ e.textContent = pad(h); });
    document.querySelectorAll('[data-st="m"]').forEach(function(e){ e.textContent = pad(m); });
    document.querySelectorAll('[data-st="s"]').forEach(function(e){ e.textContent = pad(s); });
  }

  /* ---------- carousels ---------- */
  function rail(btn){ return btn.closest('section').querySelector('.hhRail'); }
  function pages(r){
    var g = parseFloat(getComputedStyle(r).columnGap) || 14;
    return Math.max(1, Math.ceil((r.scrollWidth - r.clientWidth - 4)/(r.clientWidth + g)) + 1);
  }
  /* One dot per page put ten identical circles across the width of a phone,
     which told the reader nothing and looked like a mistake. This draws a
     sliding window of at most five instead: the current page as a stretched
     pill, and the dot at either end of the window drawn smaller when there
     is more beyond it - the shape people already know from the photo app on
     their phone.

     The buttons are reused rather than rebuilt whenever the window slides,
     so the pill animates from one position to the next instead of jumping.
     Only their indices and classes change. */
  var DOTWIN = 5;
  function sync(sec){
    var r = sec.querySelector('.hhRail'), dots = sec.querySelector('.hhDots');
    if(!r || !dots) return;
    var gap = parseFloat(getComputedStyle(r).columnGap) || 14;
    var n = pages(r);
    var cur = Math.round(r.scrollLeft / (r.clientWidth + gap));
    if(cur < 0) cur = 0;
    if(cur > n - 1) cur = n - 1;

    var span = Math.min(DOTWIN, n);
    var start = Math.max(0, Math.min(cur - Math.floor(span / 2), n - span));

    if(dots.children.length !== span){
      dots.innerHTML = '';
      for(var i = 0; i < span; i++){
        var b = document.createElement('button');
        b.className = 'hhDot';
        dots.appendChild(b);
      }
    }
    Array.prototype.forEach.call(dots.children, function(d, k){
      var idx = start + k;
      d.setAttribute('data-hhdot', idx);
      d.setAttribute('aria-label', 'Page ' + (idx + 1) + ' of ' + n);
      d.classList.toggle('on', idx === cur);
      d.classList.toggle('hhDot--sm', idx !== cur &&
        ((k === 0 && start > 0) || (k === span - 1 && start + span < n)));
    });

    var prev = sec.querySelector('[data-hh="-1"]'), next = sec.querySelector('[data-hh="1"]');
    if(prev) prev.disabled = cur <= 0;
    if(next) next.disabled = cur >= n - 1;
  }
  document.addEventListener('click', function(e){
    var nav = e.target.closest('[data-hh]');
    if(nav){
      var r = rail(nav), g = parseFloat(getComputedStyle(r).columnGap)||14;
      r.scrollBy({left: parseInt(nav.getAttribute('data-hh'),10) * (r.clientWidth + g), behavior:'smooth'});
      return;
    }
    var dot = e.target.closest('[data-hhdot]');
    if(dot){
      var r2 = rail(dot), g2 = parseFloat(getComputedStyle(r2).columnGap)||14;
      r2.scrollTo({left: parseInt(dot.getAttribute('data-hhdot'),10) * (r2.clientWidth + g2), behavior:'smooth'});
    }
  });

  function initCarousels(){
    document.querySelectorAll('section .hhRail').forEach(function(r){
      var sec = r.closest('section');
      sync(sec);
      r.addEventListener('scroll', function(){ clearTimeout(r._t); r._t = setTimeout(function(){ sync(sec); }, 90); });
    });
  }

  /* ---------- init ---------- */
  function init(){
    refreshCart();
    if(document.querySelector('.saletimer')){ tickSale(); setInterval(tickSale, 1000); }
    initCarousels();
    window.addEventListener('resize', function(){ clearTimeout(window._rz); window._rz = setTimeout(initCarousels, 150); });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();